/* To The Max Golf — behaviour and motion for the ttm-* sections. */
(() => {
  const doc = document;
  const root = doc.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  const $ = (sel, ctx = doc) => ctx.querySelector(sel);
  const $$ = (sel, ctx = doc) => [...ctx.querySelectorAll(sel)];
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  /* ---------- reveal on scroll ---------- */
  const io =
    'IntersectionObserver' in window && !designMode
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        )
      : null;

  function initReveal(scope = doc) {
    $$('[data-stagger]', scope).forEach((group) => {
      const per = Number(group.dataset.stagger) || 6;
      [...group.children].forEach((child, i) => {
        if (!child.hasAttribute('data-reveal')) child.setAttribute('data-reveal', 'pop');
        child.style.setProperty('--i', i % per);
      });
    });
    $$('[data-lines]', scope).forEach((el) => {
      $$('.t-line', el).forEach((line, i) => line.style.setProperty('--i', i));
    });
    $$('[data-reveal], [data-inview]', scope).forEach((el) => {
      if (io) io.observe(el);
      else el.classList.add('is-in');
    });
  }

  /* ---------- header ---------- */
  function initHeader() {
    const header = $('[data-ttm-header]');
    if (!header) return;
    const megas = $$('[data-mega-panel]', header);
    const triggers = $$('[data-mega]', header);
    const mob = $('[data-mob-panel]', header);
    const mobBtn = $('[data-mob-toggle]', header);
    const pop = $('[data-bag]', header);
    const bagBtn = $('[data-bag-toggle]', header);
    const badge = $('[data-bag-count]', header);
    let closeTimer;

    const closeMega = () => {
      megas.forEach((panel) => (panel.hidden = true));
      triggers.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    };
    const openMega = (btn) => {
      clearTimeout(closeTimer);
      const panel = doc.getElementById(btn.getAttribute('aria-controls'));
      if (!panel || !panel.hidden) return;
      closeMega();
      closeBag();
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    };
    const closeMob = () => {
      if (!mob) return;
      mob.hidden = true;
      mobBtn.setAttribute('aria-expanded', 'false');
    };
    function closeBag() {
      if (!pop) return;
      pop.hidden = true;
      bagBtn.setAttribute('aria-expanded', 'false');
    }

    triggers.forEach((btn) => {
      btn.addEventListener('mouseenter', () => openMega(btn));
      btn.addEventListener('focus', () => openMega(btn));
      btn.addEventListener('click', () => openMega(btn));
    });
    $$('.t-nv:not([data-mega])', header).forEach((link) => link.addEventListener('mouseenter', closeMega));
    $$('[data-mega-close]', header).forEach((btn) => btn.addEventListener('click', closeMega));
    header.addEventListener('mouseleave', () => (closeTimer = setTimeout(closeMega, 140)));
    header.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    doc.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeMega();
      closeMob();
      closeBag();
    });
    doc.addEventListener('click', (event) => {
      if (pop && !pop.hidden && !header.contains(event.target)) closeBag();
    });

    if (mobBtn && mob) {
      mobBtn.addEventListener('click', () => {
        const open = mob.hidden;
        closeMega();
        closeBag();
        mob.hidden = !open;
        mobBtn.setAttribute('aria-expanded', String(open));
      });
    }

    /* the utility bar scrolls away under a negative sticky offset */
    const util = $('[data-util]', header);
    const setOffset = () => header.parentElement.style.setProperty('--util-h', `${util ? util.offsetHeight : 0}px`);
    setOffset();
    window.addEventListener('resize', setOffset);

    /* pinned state + fairway progress */
    let ticking = false;
    const onScroll = () => {
      ticking = false;
      const y = window.scrollY;
      if (y > 90) header.classList.add('is-stuck');
      else if (y < 20) header.classList.remove('is-stuck');
      const max = root.scrollHeight - window.innerHeight;
      header.style.setProperty('--p', max > 0 ? clamp(y / max, 0, 1).toFixed(4) : 0);
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) requestAnimationFrame(onScroll);
        ticking = true;
      },
      { passive: true }
    );
    onScroll();

    /* bag: Shopify Ajax Cart API */
    if (!pop) return;
    const urls = { cart: header.dataset.cartUrl, add: header.dataset.cartAddUrl, change: header.dataset.cartChangeUrl };
    const format = header.dataset.money || '${{amount}}';
    const money = (cents) => {
      const amount = (cents / 100).toFixed(2);
      const whole = Math.round(cents / 100).toString();
      return format
        .replace(/\{\{\s*amount_no_decimals[a-z_]*\s*\}\}/, whole)
        .replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.endsWith('.00') ? whole : amount);
    };
    const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    const post = (url, body) =>
      fetch(`${url}.js`, { method: 'POST', headers: json, body: JSON.stringify(body) }).then((res) => {
        if (!res.ok) throw new Error(`Cart request failed: ${res.status}`);
        return res.json();
      });
    const getCart = () => fetch(`${urls.cart}.js`, { headers: { Accept: 'application/json' } }).then((res) => res.json());

    const empty = $('[data-bag-empty]', pop);
    const full = $('[data-bag-full]', pop);
    const lines = $('[data-bag-lines]', pop);
    const subtotal = $('[data-bag-subtotal]', pop);

    const el = (tag, cls, text) => {
      const node = doc.createElement(tag);
      if (cls) node.className = cls;
      if (text != null) node.textContent = text;
      return node;
    };
    const stepper = (label, sign, onClick) => {
      const btn = el('button', 't-step', sign);
      btn.type = 'button';
      btn.setAttribute('aria-label', label);
      btn.addEventListener('click', onClick);
      return btn;
    };

    function renderBag(cart, bump) {
      badge.textContent = cart.item_count;
      if (bump && !reduce) {
        badge.classList.remove('is-bump');
        void badge.offsetWidth;
        badge.classList.add('is-bump');
      }
      empty.hidden = cart.item_count > 0;
      full.hidden = cart.item_count === 0;
      subtotal.textContent = money(cart.total_price);
      lines.replaceChildren(
        ...cart.items.map((item) => {
          const row = el('div', 't-pop__line');
          const info = el('div');
          const name = el('a', null, item.product_title || item.title);
          name.href = item.url;
          name.style.cssText = 'display:block;font-weight:600;font-size:15px';
          info.append(name, el('div', 't-mute', money(item.final_line_price ?? item.line_price)));
          const qty = el('div', 't-pop__qty');
          const change = (quantity) => () =>
            post(urls.change, { id: item.key, quantity }).then((next) => renderBag(next, true)).catch(console.error);
          qty.append(
            stepper('Remove one', '−', change(item.quantity - 1)),
            el('span', null, item.quantity),
            stepper('Add one', '+', change(item.quantity + 1))
          );
          row.append(info, qty);
          return row;
        })
      );
    }
    const refreshBag = (bump) => getCart().then((cart) => renderBag(cart, bump)).catch(console.error);
    const openBag = () => {
      closeMega();
      closeMob();
      pop.hidden = false;
      bagBtn.setAttribute('aria-expanded', 'true');
    };

    bagBtn.addEventListener('click', () => {
      if (pop.hidden) {
        openBag();
        refreshBag(false);
      } else closeBag();
    });
    $('[data-bag-close]', pop).addEventListener('click', closeBag);

    function flyBall(from) {
      if (reduce || !from) return Promise.resolve();
      const a = from.getBoundingClientRect();
      const b = bagBtn.getBoundingClientRect();
      const ball = el('span', 't-flyball');
      doc.body.append(ball);
      const x0 = a.left + a.width / 2;
      const y0 = a.top + a.height / 2;
      const x1 = b.left + b.width / 2;
      const y1 = b.top + b.height / 2;
      const apex = Math.min(y0, y1) - 120;
      const frames = [];
      for (let i = 0; i <= 20; i++) {
        const t = i / 20;
        const x = x0 + (x1 - x0) * t;
        const y = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * apex + t * t * y1;
        frames.push({ transform: `translate(${x}px, ${y}px) scale(${1 - t * 0.45})` });
      }
      return ball
        .animate(frames, { duration: 750, easing: 'cubic-bezier(.3,.5,.4,1)' })
        .finished.then(() => ball.remove());
    }

    doc.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-add]');
      if (!btn || btn.disabled) return;
      event.preventDefault();
      const label = btn.textContent;
      btn.disabled = true;
      const landed = Promise.race([flyBall(btn), new Promise((resolve) => setTimeout(resolve, 900))]);
      const qty = $('[data-qty]', btn.closest('[data-product]') || btn);
      const quantity = Math.max(1, Number(qty && qty.value) || 1);
      Promise.all([post(urls.add, { id: Number(btn.dataset.add), quantity }), landed])
        .then(() => {
          btn.classList.add('is-done');
          btn.textContent = btn.dataset.added || 'Added';
          openBag();
          return refreshBag(true);
        })
        .catch((error) => {
          console.error(error);
          btn.textContent = btn.dataset.error || 'Try again';
        })
        .finally(() =>
          setTimeout(() => {
            btn.disabled = false;
            btn.classList.remove('is-done');
            btn.textContent = label;
          }, 1600)
        );
    });
  }

  /* ---------- hero parallax ---------- */
  function initHero(scope = doc) {
    if (!fine || reduce) return;
    $$('[data-parallax]', scope).forEach((art) => {
      art.addEventListener('pointermove', (event) => {
        const r = art.getBoundingClientRect();
        art.style.setProperty('--px', (((event.clientX - r.left) / r.width - 0.5) * 2).toFixed(3));
        art.style.setProperty('--py', (((event.clientY - r.top) / r.height - 0.5) * 2).toFixed(3));
      });
      art.addEventListener('pointerleave', () => {
        art.style.setProperty('--px', 0);
        art.style.setProperty('--py', 0);
      });
    });
  }

  /* ---------- tilt cards + magnetic buttons ---------- */
  function initPointerFx(scope = doc) {
    if (!fine || reduce) return;
    $$('[data-tilt]', scope).forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const r = card.getBoundingClientRect();
        card.style.setProperty('--rx', (((event.clientX - r.left) / r.width - 0.5) * 2).toFixed(3));
        card.style.setProperty('--ry', (((event.clientY - r.top) / r.height - 0.5) * 2).toFixed(3));
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--rx', 0);
        card.style.setProperty('--ry', 0);
      });
    });
    $$('[data-magnet]', scope).forEach((btn) => {
      btn.addEventListener('pointermove', (event) => {
        const r = btn.getBoundingClientRect();
        btn.style.setProperty('--mx', `${((event.clientX - r.left - r.width / 2) * 0.18).toFixed(1)}px`);
        btn.style.setProperty('--my', `${((event.clientY - r.top - r.height / 2) * 0.3).toFixed(1)}px`);
      });
      btn.addEventListener('pointerleave', () => {
        btn.style.setProperty('--mx', '0px');
        btn.style.setProperty('--my', '0px');
      });
    });
  }

  /* ---------- word band: scroll-linked slide with velocity skew ---------- */
  function initBands() {
    const bands = $$('[data-band]');
    if (!bands.length || reduce) return;
    let last = window.scrollY;
    let skew = 0;
    const tick = () => {
      const y = window.scrollY;
      skew += (clamp((y - last) * 0.25, -9, 9) - skew) * 0.12;
      last = y;
      bands.forEach((band) => {
        const r = band.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        const progress = clamp((window.innerHeight - r.top) / (window.innerHeight + r.height), 0, 1);
        const travel = Math.max(0, band.scrollWidth - window.innerWidth);
        band.style.setProperty('--bx', (progress * travel * 0.7).toFixed(1));
        band.style.setProperty('--bv', (-skew).toFixed(2));
      });
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  /* ---------- product rail ---------- */
  function initRails(scope = doc) {
    $$('[data-rail-section]', scope).forEach((section) => {
      const tabs = $$('[data-tab]', section);
      const rails = $$('[data-rail]', section);
      const active = () => rails.find((rail) => !rail.hidden);
      rails.forEach((rail) => [...rail.children].forEach((card, i) => card.style.setProperty('--i', i)));
      tabs.forEach((tab) =>
        tab.addEventListener('click', () => {
          tabs.forEach((other) => other.setAttribute('aria-pressed', String(other === tab)));
          rails.forEach((rail) => {
            const on = rail.dataset.rail === tab.dataset.tab;
            rail.hidden = !on;
            rail.classList.remove('is-swap');
            if (!on) return;
            rail.scrollLeft = 0;
            void rail.offsetWidth;
            rail.classList.add('is-swap');
          });
        })
      );
      $$('[data-rail-move]', section).forEach((btn) =>
        btn.addEventListener('click', () => {
          const rail = active();
          if (!rail) return;
          rail.scrollBy({ left: Number(btn.dataset.railMove) * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        })
      );
    });
  }

  /* ---------- wishlist hearts (saved in this browser) ---------- */
  function initWishlist(scope = doc) {
    const key = 'ttm-wishlist';
    let saved = [];
    try {
      saved = JSON.parse(localStorage.getItem(key)) || [];
    } catch (error) {
      saved = [];
    }
    $$('[data-wish]', scope).forEach((btn) => {
      btn.setAttribute('aria-pressed', String(saved.includes(btn.dataset.wish)));
      btn.addEventListener('click', () => {
        const on = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', String(on));
        saved = on ? [...saved, btn.dataset.wish] : saved.filter((id) => id !== btn.dataset.wish);
        try {
          localStorage.setItem(key, JSON.stringify(saved));
        } catch (error) {
          /* private mode: the heart still toggles for this visit */
        }
      });
    });
  }

  /* ---------- fit lab ---------- */
  function initFitLab(scope = doc) {
    $$('[data-fitlab]', scope).forEach((lab) => {
      const range = $('[data-speed]', lab);
      if (range) {
        const segs = $$('[data-flex-max]', lab);
        const name = $('[data-flex-out]', lab);
        const link = $('[data-flex-link]', lab);
        const gauge = $('[data-gauge]', lab);
        const update = () => {
          const speed = Number(range.value);
          const seg = segs.find((s) => speed <= Number(s.dataset.flexMax)) || segs[segs.length - 1];
          $$('[data-speed-out]', lab).forEach((out) => (out.textContent = speed));
          $('[data-kmh-out]', lab).textContent = Math.round(speed * 1.609);
          gauge.style.setProperty('--g', ((speed - range.min) / (range.max - range.min)).toFixed(3));
          segs.forEach((s) => s.classList.toggle('is-on', s === seg));
          if (name.textContent !== seg.dataset.flexName) {
            name.textContent = seg.dataset.flexName;
            name.classList.remove('is-flip');
            void name.offsetWidth;
            name.classList.add('is-flip');
            if (link) link.textContent = link.dataset.flexLink.replace('[flex]', seg.dataset.flexName);
          }
        };
        range.addEventListener('input', update);
        update();
      }

      const clubs = $$('[data-club]', lab);
      if (!clubs.length) return;
      const limit = 14;
      const slots = $$('[data-slot]', lab);
      const total = $('[data-bag-total]', lab);
      const msg = $('[data-bag-msg]', lab);
      const count = (club) => Number($('output', club).textContent);
      const sync = () => {
        const sum = clubs.reduce((n, club) => n + count(club), 0);
        const left = limit - sum;
        total.textContent = sum;
        slots.forEach((slot, i) => slot.classList.toggle('is-on', i < sum));
        slots[0].parentElement.setAttribute('aria-label', `${sum} of ${limit} club slots filled`);
        clubs.forEach((club) => {
          $('[data-less]', club).disabled = count(club) === 0;
          $('[data-more]', club).disabled = left === 0;
        });
        msg.textContent =
          sum === 0 ? msg.dataset.empty : left === 0 ? msg.dataset.full : msg.dataset.left.replace('[n]', left).replace('[s]', left === 1 ? '' : 's');
      };
      const set = (club, n) => ($('output', club).textContent = Math.max(0, n));
      clubs.forEach((club) => {
        $('[data-less]', club).addEventListener('click', () => (set(club, count(club) - 1), sync()));
        $('[data-more]', club).addEventListener('click', () => (set(club, count(club) + 1), sync()));
      });
      $('[data-bag-preset]', lab).addEventListener('click', () => {
        clubs.forEach((club) => set(club, Number(club.dataset.typical) || 0));
        sync();
      });
      $('[data-bag-clear]', lab).addEventListener('click', () => {
        clubs.forEach((club) => set(club, 0));
        sync();
      });
      sync();
    });
  }

  /* ---------- product page: variants, quantity, gallery ---------- */
  function initProduct(scope = doc) {
    $$('[data-product]', scope).forEach((page) => {
      const add = $('[data-add]', page);
      const price = $('[data-price]', page);
      const compare = $('[data-compare]', page);
      const tag = $('[data-sale-tag]', page);
      $$('input[name="id"][type="radio"]', page).forEach((radio) =>
        radio.addEventListener('change', () => {
          if (add) add.dataset.add = radio.value;
          price.textContent = radio.dataset.price;
          compare.textContent = radio.dataset.compare;
          compare.hidden = !radio.dataset.compare;
          if (tag) tag.hidden = !radio.dataset.compare;
          const url = new URL(location.href);
          url.searchParams.set('variant', radio.value);
          history.replaceState(null, '', url);
        })
      );
      const qty = $('[data-qty]', page);
      $$('[data-qty-step]', page).forEach((btn) =>
        btn.addEventListener('click', () => (qty.value = Math.max(1, (Number(qty.value) || 1) + Number(btn.dataset.qtyStep))))
      );
      const stage = $('[data-stage-image]', page);
      const thumbs = $$('[data-thumb]', page);
      thumbs.forEach((thumb) =>
        thumb.addEventListener('click', () => {
          stage.src = thumb.dataset.thumb;
          thumbs.forEach((other) => other.setAttribute('aria-pressed', String(other === thumb)));
        })
      );
    });
  }

  /* ---------- footer wordmark ---------- */
  function initWordmarks(scope = doc) {
    $$('[data-split]', scope).forEach((mark) => {
      const text = mark.textContent.trim();
      mark.replaceChildren(
        ...[...text].map((char, i) => {
          const span = doc.createElement('span');
          span.textContent = char;
          span.style.setProperty('--i', i);
          return span;
        })
      );
    });
  }

  function init(scope) {
    initWordmarks(scope);
    initReveal(scope);
    initHero(scope);
    initPointerFx(scope);
    initRails(scope);
    initWishlist(scope);
    initFitLab(scope);
    initProduct(scope);
  }

  const boot = () => {
    init(doc);
    initHeader();
    initBands();
  };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* theme editor: re-run for sections that are added or re-rendered */
  doc.addEventListener('shopify:section:load', (event) => {
    init(event.target);
    if ($('[data-ttm-header]', event.target)) initHeader();
  });
})();
